/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'building/monument_open': {
    width: 32,
    height: 32,
    viewBox: '0 0 32 32',
    data: '<path pid="0" d="M4.5 32H0v-4.5h1V31h3.5zM32 32h-4.5v-1H31v-3.5h1zM32 4.5h-1V1h-3.5V0H32zM1 4.5H0V0h4.5v1H1zM20 26h6v1h-6zM6 26h6v1H6zM20 24h5v1h-5zM7 24h5v1H7zM20 22h4v1h-4zM8 22h4v1H8zM16 5a8 8 0 00-8 8v8h4v-8a4 4 0 018 0v8h4v-8a8 8 0 00-8-8z"/><circle pid="1" cx="16" cy="13" r="2"/>'
  }
})
